<template>
  <div
    v-if="list && list.length"
    class="default_box infoBlock"
  >
    <label
      v-if="status === 'success'"
      class="success_color"
    >Успешно ({{ list.length }})</label>
    <label
      v-else-if="status === 'danger'"
      class="danger_color"
    >Ошибки ({{ list.length }}) <button
      class="btn_download"
      @click="$parent.saveResult(list)"
    >(Скачать)</button></label>
    <div
      v-if="list && list.length"
      class="infoBlock_box"
    >
      <p
        v-for="item in reversedItems"
        :key="item.id"
        v-html="`• ${item.name}`"
      />
    </div>
  </div>
</template>
<script>
export default {
    name: "InfoBlock",
    components: {},
    props: {
        status: {
            type: String
        },
        list: {
            type: Array
        }
    },
    data() {
        return {}
    },
    computed: {
      reversedItems() {
        return this.list.slice(-50).reverse();
      },
    },
    mounted() {

    },
    methods: {},
}
</script>
<style scoped>
.infoBlock {
    text-align: left;
}

.infoBlock label {
    display: block;
    font-size: 14px;
    font-weight: bold;
    padding-bottom: 5px;
    text-transform: uppercase;
    border-bottom: 1px dashed rgba(0, 0, 0, 0.2);
}

.infoBlock_box {
    padding: 15px 0;
    max-height: 300px;
    overflow-y: auto;
}

.infoBlock p {
    margin: 0;
    font-size: 12px;
}

.infoBlock p:not(:last-child) {
    padding: 0 0 10px;    
}

.btn_download {
    font-size: 12px;
    color: #999;
    text-transform: uppercase;
    display: inline-block;
    transition: .2s;
}

.btn_download:hover {
    color: rgba(var(--main-color), 1.0);
    transition: .2s;
}
</style>